var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-admin-templates",
    },
    [
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [_c("translate", [_vm._v("Vorlagen")])], 1),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_c("translate", [_vm._v("Art des Lernmaterials")])], 1),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Name")])], 1),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_c("translate", [_vm._v("Aktionen")])],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.templates, function (template) {
              return _c(
                "tr",
                {
                  key: template.id,
                },
                [
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.getPurposeName(template.attributes.purpose))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(template.attributes.name))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                    },
                    [
                      _c("studip-action-menu", {
                        attrs: {
                          items: _vm.menuItems,
                        },
                        on: {
                          editTemplate: function editTemplate($event) {
                            return _vm.editTemplate(template.id)
                          },
                          deleteTemplate: function deleteTemplate($event) {
                            return _vm.confimDeleteTemplate(template.id)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showAddTemplateDialog
        ? _c("studip-dialog", {
            staticClass: "cw-admin-template-dialog",
            attrs: {
              title: _vm.$gettext("Vorlage hinzufügen"),
              confirmText: _vm.$gettext("Erstellen"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
              height: "360",
            },
            on: {
              close: _vm.closeAddDialog,
              confirm: _vm.createNewTemplate,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Name der neuen Vorlage"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newTemplateName,
                                    expression: "newTemplateName",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.newTemplateName,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.newTemplateName = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Art des Lernmaterials"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newElementPurpose,
                                      expression: "newElementPurpose",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.newElementPurpose = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "content",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Inhalt")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "template",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Aufgabenvorlage"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "oer",
                                      },
                                    },
                                    [_c("translate", [_vm._v("OER-Material")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "portfolio",
                                      },
                                    },
                                    [_c("translate", [_vm._v("ePortfolio")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "draft",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Entwurf")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "other",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Sonstiges")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Vorlage")]),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.chooseFile.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("translate", [
                                    _vm._v("Vorlage-Archiv auswählen"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.importZip
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cw-import-zip",
                                    },
                                    [
                                      _c("header", [
                                        _vm._v(_vm._s(_vm.importZip.name)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("input", {
                                ref: "importFile",
                                staticStyle: {
                                  visibility: "hidden",
                                },
                                attrs: {
                                  type: "file",
                                  accept: ".zip",
                                },
                                on: {
                                  change: _vm.setImport,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3664099568
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditTemplateDialog
        ? _c("studip-dialog", {
            staticClass: "cw-admin-template-dialog",
            attrs: {
              title: _vm.$gettext("Vorlage bearbeiten"),
              confirmText: _vm.$gettext("Speichern"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
            },
            on: {
              close: _vm.closeEditDialog,
              confirm: _vm.updateCurrentTemplate,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Name der neuen Vorlage"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTemplate.attributes.name,
                                    expression:
                                      "currentTemplate.attributes.name",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTemplate.attributes.name,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.currentTemplate.attributes,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Art des Lernmaterials"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.currentTemplate.attributes.purpose,
                                      expression:
                                        "currentTemplate.attributes.purpose",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.currentTemplate.attributes,
                                        "purpose",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "content",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Inhalt")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "template",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Aufgabenvorlage"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "oer",
                                      },
                                    },
                                    [_c("translate", [_vm._v("OER-Material")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "portfolio",
                                      },
                                    },
                                    [_c("translate", [_vm._v("ePortfolio")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "draft",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Entwurf")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "other",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Sonstiges")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3074852134
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Vorlage löschen"),
              question: _vm.$gettext(
                "Möchten Sie diese Vorlage wirklich löschen?"
              ),
              height: "180",
            },
            on: {
              confirm: _vm.deleteCurrentTemplate,
              close: _vm.closeDeleteDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }